import { doArraysHaveCommonElements } from '../../../../../../../helpers/arrays'

import { ENVIRONMENT_TYPE, environmentTypes } from '../../fields'

type EnvironmentType = (typeof environmentTypes)[keyof typeof environmentTypes]

interface InventoryTargeting {
  targeted_placement_ids?: number[]
  targeted_ad_units?: { ad_unit_id: number }[]
  [key: string]: any
}

interface Targeting {
  inventory_targeting?: InventoryTargeting
  [key: string]: any
}

interface LineItem {
  date_start: string
  date_stop: string
  name: string
  targeting?: Targeting
  [key: string]: any
}

export const getLineItemTargetedInventory = (lineItem: LineItem): number[] => {
  const inventoryTargeting = lineItem?.targeting?.inventory_targeting
  if (!inventoryTargeting) return []

  const placementIds = inventoryTargeting.targeted_placement_ids || []
  const adUnitIds =
    inventoryTargeting.targeted_ad_units?.map((unit: { ad_unit_id: any }) => Number(unit.ad_unit_id)) || []

  if (placementIds?.length) {
    return placementIds
  } else if (adUnitIds?.length) {
    return adUnitIds
  } else {
    return []
  }
}

interface GetLineItemsWithInventoryOverlapParams {
  existingLineItems: LineItem[]
  proposedInventoryIds: number[]
  environmentType: EnvironmentType
}

// Returns line items that have inventory overlap with proposed inventory
// Filters to only line items targeting any of the proposed inventory
export const getLineItemsWithInventoryOverlap = ({
  existingLineItems,
  proposedInventoryIds,
  environmentType
}: GetLineItemsWithInventoryOverlapParams): LineItem[] => {
  if (!existingLineItems?.length || !proposedInventoryIds || proposedInventoryIds.length === 0) {
    return []
  }

  return (
    existingLineItems
      .filter(lineItem => {
        // Only consider line items that are active in the given environment
        return lineItem[ENVIRONMENT_TYPE] === environmentType
      })
      // Filter to only line items that have inventory overlap with proposed inventory
      .filter(lineItem => {
        const existingInventoryIds = getLineItemTargetedInventory(lineItem)
        return doArraysHaveCommonElements(proposedInventoryIds, existingInventoryIds)
      })
  )
}
